import axios from 'axios'
const donemUpdate = async (data) => {
    let response;
    var config = {
        method: 'put',
        url: process.env.REACT_APP_BASE_URL+'/api/v1/donem/update',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
        data: data,
    };
    await axios(config)
        .then((res) => {
            
            response = res;
        })
        .catch((err) => {
            console.log(err);
        });
    return response;
};

export default donemUpdate;
